import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, Link } from 'react-router-dom'
import Captcha from '../Captcha'
import { loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha'

function Register() {
  const [pesan, setPesan] = useState(false)
  const [data, setData] = useState(1)
  const [profil, setProfil] = useState(0)
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [nik, setNIK] = useState('')
  const [nib, setNIB] = useState('')
  const [no_npwp, setNPWP] = useState('')
  const [nm_usaha, setNmUsaha] = useState('')
  const [nm_lengkap, setNmLengkap] = useState('')
  const [no_hp, setNoHp] = useState('')
  const [no_kec, setNoKec] = useState('')
  const [no_kel, setNoKel] = useState('')
  const [no_rw, setNoRw] = useState('')
  const [no_rt, setNoRt] = useState('')
  const [alamat, setAlamat] = useState('')
  const [kd_pos, setKdPos] = useState('')
  const [kecamatan, setKecamatan] = useState([])
  const [kelurahan, setKelurahan] = useState([])
  const [captcha, setCaptcha] = useState("")
  const [recaptcha, setReCaptcha] = useState("")
  const [type, setType] = useState('password')
  const [msg, setMsg] = useState('')
  const navigate = useNavigate()
  const alert = {
    position: "relative",
    top: "7px",
    backgroundColor: "#e5df7c",
    color: "#333",
  }

  useEffect(() => {
    getKecamatan()
    loadCaptchaEnginge(6)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getKecamatan = async () => {
    try {
      const response = await axios.post(`/api/wilayah/kecamatan`, {
        no_prop: '32',
        no_kab: '75',
      })
      setKecamatan(response.data)
      setNoKec('')
    } catch {
      setKecamatan([])
      setNoKec("")
    }
  }

  const getKelurahan = async (key) => {
    try {
      const response = await axios.post(`/api/wilayah/kelurahan`, {
        no_prop: '32',
        no_kab: '75',
        no_kec: key
      })
      setKelurahan(response.data)
      setNoKel('')
      setNoKec(key)
    } catch {
      setKelurahan([])
      setNoKel("")
      setNoKec(key)
    }
  }

  const typePassword = () => {
    if (type === "password") {
      setType('text')
    } else {
      setType('password')
    }
  }

  const getData = (e) => {
    e.preventDefault()
    setProfil(0)
    setData(1)
  }

  const getProfil = async (e) => {
    e.preventDefault()

    const rules = [
      { test: nik.length !== 16, msg: 'NIK harus 16 digit!' },
      { test: nm_lengkap === '', msg: 'Harap masukan nama lengkap!' },
      { test: username === '', msg: 'Harap masukan username!' },
      { test: email === '', msg: 'Harap masukan email!' },
      { test: password.length < 8, msg: 'Password min 8 digit!' },
      { test: no_hp.length < 10, msg: 'No hp min 10 digit!' },
      { test: no_hp.length > 17, msg: 'No hp max 17 digit!' },
    ]

    const error = rules.find(rule => rule.test)

    if (error) {
      getPesan()
      setMsg(error.msg)
      return setTimeout(() => {
        getPesan()
        setMsg('')
      }, 2000)
    }

    try {
      const payload = {
        nik: nik.trim(),
        username: username.trim(),
        email: email.trim().toLowerCase(),
        password,
        no_hp: no_hp.trim()
      }

      await axios.post("/api/pelaku-usaha/validasi", payload)
      setProfil(1)
      setData(0)
    } catch (err) {
      setProfil(0)
      setData(1)
      getPesan()
      const errorMsg = (err.response && err.response.data && err.response.data.msg)
        || 'Maaf, proses pengiriman data gagal!'
      setMsg(errorMsg)
      setTimeout(() => {
        getPesan()
        setMsg("")
      }, 2000)
    }
  }

  const getWaktuSekarang = () => {
    const d = new Date()
    const date = d.toISOString().split('T')[0] // Hasil: 2024-06-06
    const time = d.toTimeString().split(' ')[0] // Hasil: 09:59:42
    return `${date} ${time}`
  }

  const proses = async (e) => {
    e.preventDefault()

    const rules = [
      { test: nib === '', msg: 'Harap masukan NIB!' },
      { test: no_npwp === '', msg: 'Harap masukan No. NPWP!' },
      { test: nm_usaha === '', msg: 'Harap masukan nama usaha!' },
      { test: no_kec === '', msg: 'Harap pilih Kecamatan!' },
      { test: no_kel === '', msg: 'Harap pilih Kelurahan!' },
      { test: alamat === '', msg: 'Harap masukan alamat!' },
      { test: no_rt === '', msg: 'Harap masukan No. RT!' },
      { test: no_rw === '', msg: 'Harap masukan No. RW!' },
      { test: kd_pos === '', msg: 'Harap masukan kode pos!' },
    ]

    const error = rules.find(rule => rule.test)

    if (error) {
      getPesan()
      setMsg(error.msg)
      return setTimeout(() => {
        getPesan()
        setMsg('')
      }, 2000)
    }

    // 1. Early Return untuk Captcha
    if (!validateCaptcha(captcha)) {
      setReCaptcha("Captcha tidak sesuai!")
      setTimeout(() => setReCaptcha(""), 2000)
      setCaptcha("")
      return // Stop di sini
    }

    // 2. Eksekusi Simpan
    try {
      const waktu = getWaktuSekarang()

      const payload = {
        username, email, password, nik, nm_lengkap, no_hp,
        jenis: 1,
        pemohon: username,
        waktu: waktu
      }

      const simpan = await axios.post("/api/pelaku-usaha/register", payload)

      await perorangan(simpan.data.userId)

      getPesan()
      setMsg(simpan.data.msg)
      setTimeout(() => {
        getPesan()
        setMsg("")
        navigate('/login')
      }, 1000)

    } catch (err) {
      getPesan()
      const errorMsg = (err.response && err.response.data && err.response.data.msg)
        || 'Maaf, proses pengiriman data gagal!'
      setMsg(errorMsg)
      setTimeout(() => {
        getPesan()
        setMsg("")
      }, 2000)
    }
  }

  const perorangan = async (token) => {
    const waktu = getWaktuSekarang()

    const payload = {
      token: token,
      nik, 
      nib, 
      no_npwp,
      nm_usaha,
      nm_lengkap,
      no_kec,
      no_kel,
      no_rw,
      no_rt,
      alamat,
      kd_pos,
      waktu: waktu
    }

    try {
      await axios.post("/api/perorangan", payload)
    } catch (err) {
      console.error("Gagal simpan profil perorangan:", err)
      throw err // Biar ditangkep sama catch di fungsi 'proses'
    }
  }

  const getPesan = () => {
    setPesan((prevState) => !prevState)
  }

  const display = {
    display: `${pesan ? "block" : "none"}`,
  }

  return (
    <>
      <div className="bg-full-page bg-primary back-fixed">
        <div className="mw-800 absolute-center">
          <div className="card color-dark animated zoomInDown animation-delay-5 border-radius-20">
            <div className="card-body">
              <div className="row mb-2">
                <div className="col-md-8 col-6">
                  <h3 className="color-success">Pendaftaran Akun</h3>
                </div>
                <div className="col-md-4 col-6">
                  <img width="100%" src="assets/img/logo-head.png" alt="" />
                </div>
                <div className="col-md-12">
                  <img width="100%" className="line-process" src="assets/img/line.png" alt="" />
                </div>
                <div className="col-md-4 col-4 text-center">
                  <button className={(data === 1 | profil === 1) ? 'btn-circle btn-circle-raised btn-circle-success' : 'btn-circle btn-circle-raised btn-circle-default'}>1</button>
                  <br></br>Jenis Usaha
                </div>
                <div className="col-md-4 col-4 text-center">
                  <button className={(data === 1 | profil === 1) ? 'btn-circle btn-circle-raised btn-circle-success' : 'btn-circle btn-circle-raised btn-circle-default'}>2</button>
                  <br></br>Data Pengguna Aplikasi
                </div>
                <div className="col-md-4 col-4 text-center">
                  <button className={profil === 1 ? 'btn-circle btn-circle-raised btn-circle-success' : 'btn-circle btn-circle-raised btn-circle-default'}>3</button>
                  <br></br>Profil Pelaku Usaha
                </div>
                <div className="col-md-12 col-12 text-center">
                  <span className="badge d-inline-block text-wrap badge-danger">
                    Pastikan menggunakan email aktif ketika mendaftarkan akun (<b>Link Aktivasi Akun kami kirim melalui email</b>)
                  </span><br></br>
                </div>
              </div>
              <div className={data === 1 ? 'd-block' : 'd-none'}>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label className="control-label" htmlFor="nik">NIK *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-id-badge"></i></span>
                      <input type="text" id="nik" className="form-control" value={nik} onChange={(e) => setNIK(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="control-label" htmlFor="nm_lengkap">Nama Lengkap *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-address-card"></i></span>
                      <input type="text" id="nm_lengkap" className="form-control" value={nm_lengkap} onChange={(e) => setNmLengkap(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="control-label" htmlFor="username-login">Nama Pengguna (Username) *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="zmdi zmdi-account"></i></span>
                      <input type="text" id="username-login" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="control-label" htmlFor="email-login">Email *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="zmdi zmdi-email"></i></span>
                      <input type="text" id="email-login" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="control-label" htmlFor="password-login">Kata Kunci (Password) *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="zmdi zmdi-lock"></i></span>
                      <input type={type} id="password-login" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
                      <span className="input-group-addon">
                        <span onClick={typePassword}><i className="control-label zmdi zmdi-eye"></i></span>
                      </span>
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="control-label" htmlFor="nm_lengkap">No. HP *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="zmdi zmdi-phone"></i></span>
                      <input type="text" id="no_hp" className="form-control" value={no_hp} onChange={(e) => setNoHp(e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>
              <div className={(profil === 1) ? 'd-block' : 'd-none'}>
                <h5 className="right-line color-success">Data Pelaku Usaha</h5>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label className="control-label">NIB *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-id-badge"></i></span>
                      <input type="text" className="form-control" value={nib} onChange={(e) => setNIB(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="control-label" htmlFor="npwp">No. NPWP *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-id-badge"></i></span>
                      <input type="text" id="npwp" className="form-control" value={no_npwp} onChange={(e) => setNPWP(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-12">
                    <label className="control-label" htmlFor="nm_usaha">Nama Usaha *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-id-badge"></i></span>
                      <input type="text" id="nm_usaha" className="form-control" value={nm_usaha} onChange={(e) => setNmUsaha(e.target.value)} />
                    </div>
                  </div>
                </div>
                <h5 className="right-line color-success">Alamat KTP</h5>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label className="control-label">Kecamatan *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-map"></i></span>
                      <select className="form-control" value={no_kec} onChange={(e) => getKelurahan(e.target.value)} required>
                        <option value="">==</option>
                        {kecamatan.map((val, i) => (
                          <option key={i} value={val.no_kec}>{i + 1 + '. ' + val.nama_kec}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="control-label">Kelurahan *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-map"></i></span>
                      <select className="form-control" value={no_kel} onChange={(e) => setNoKel(e.target.value)} required>
                        <option value="">==</option>
                        {kelurahan.map((val, i) => (
                          <option key={i} value={val.no_kel}>{i + 1 + '. ' + val.nama_kel}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="control-label" htmlFor="alamat">Alamat *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-map"></i></span>
                      <input type="text" id="alamat" className="form-control" value={alamat} onChange={(e) => setAlamat(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-2">
                    <label className="control-label" htmlFor="no_rt">No. Rt *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-map"></i></span>
                      <input type="text" id="no_rt" className="form-control" value={no_rt} onChange={(e) => setNoRt(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-2">
                    <label className="control-label" htmlFor="no_rw">No. Rw *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-map"></i></span>
                      <input type="text" id="no_rw" className="form-control" value={no_rw} onChange={(e) => setNoRw(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group col-md-2">
                    <label className="control-label" htmlFor="kd_pos">Kode Pos *</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-map"></i></span>
                      <input type="text" id="kd_pos" className="form-control" value={kd_pos} onChange={(e) => setKdPos(e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>
              <div className={(profil === 1) ? 'd-block' : 'd-none'}>
                <h5 className="right-line color-success">Captcha</h5>
                <div className="row">
                  <div className="form-group col-md-12">
                    <div className="text-center">
                      <Captcha />
                    </div>
                    <label className="control-label">Captcha</label>
                    <p style={alert} className="text-center">
                      {recaptcha}
                    </p>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-lock"></i></span>
                      <input className="form-control" type="text" value={captcha} placeholder="Masukan Captcha *" onChange={(e) => setCaptcha(e.target.value)} required />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row ">
                <div className={profil === 0 ? 'col-md-6 col-6 d-block' : 'col-md-6 col-6 d-none'}>
                  <Link to={'/register'} className="btn btn-raised btn-default btn-block p-1 br-2"><i className="zmdi zmdi-long-arrow-left no-ml mr-1"></i>KEMBALI</Link>
                </div>
                <div className={profil === 0 ? 'col-md-6 col-6 d-block' : 'col-md-6 col-6 d-none'}>
                  <button onClick={getProfil} className="btn btn-raised btn-primary btn-block p-1 br-2">SELANJUTNYA<i className="zmdi zmdi-long-arrow-right no-mr ml-1"></i></button>
                </div>
                <div className={profil === 1 ? 'col-md-6 col-6 d-block' : 'col-md-6 col-6 d-none'}>
                  <button onClick={getData} className="btn btn-raised btn-default btn-block p-1 br-2"><i className="zmdi zmdi-long-arrow-left no-ml mr-1"></i>KEMBALI</button>
                </div>
                <div className={(profil === 1) ? 'col-md-6 col-6 d-block' : 'col-md-6 col-6 d-none'}>
                  <button onClick={proses} className="btn btn-raised btn-primary btn-block p-1 br-2">DAFTAR<i className="fa fa-vcard no-mr ml-1"></i></button>
                </div>
                <div className="col-md-12 text-center mt-2">
                  Sudah punya akun? <Link className="color-success" to={'/login'}>Masuk</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={pesan ? "modal-open" : ""}>
        <div style={display} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div className="modal-dialog center">
            <div className="modal-content modal-sm">
              <div className="modal-header header-modal-primary p-1">
                <h4 className="modal-title text-center no-p font-bold" id="myModalLabel">
                  PESAN
                </h4>
              </div>
              <div className="modal-body text-center">
                <h4 className="font-bold">{msg.toUpperCase()}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>
  )
}

export default Register